module.exports = __webpack_public_path__ + "static/media/calculator.ac57b1fe.png";